import { useUpdateEffect } from 'react-use';

import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { ReceptionServiceForPractitionerSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { InteractiveTable } from '@dreryk/react-components';

import { ReceptionServiceFormController, ReceptionServiceFormPart } from './receptionService.types';
import { useReceptionServiceInteractiveTableColumns } from './ReceptionServiceInteractiveTable.hooks';
import { ReceptionServiceInteractiveTableLoader } from './ReceptionServiceInteractiveTable.loader';
import { ReceptionServiceTableBean } from './ReceptionServiceInteractiveTable.types';
import { ReceptionServiceInteractiveTableSummary } from './ReceptionServiceInteractiveTableSummary';
import { ReceptionServiceInteractiveTableSelector } from './ReceptionServiceInteractiveTableSelector';

type BaseReceptionServiceInteractiveTableProps = Pick<
   ReceptionServiceFormController,
   'register' | 'control' | 'sync' | 'setValue'
> & {
   onlinePaymentsIntegrationExists: boolean;
   receptionServices: ReceptionServiceForPractitionerSimple[];
};

const BaseReceptionServiceInteractiveTable = (props: BaseReceptionServiceInteractiveTableProps): JSX.Element => {
   const columns = useReceptionServiceInteractiveTableColumns(props.onlinePaymentsIntegrationExists);

   return (
      <>
         <InteractiveTable<ReceptionServiceTableBean, ReceptionServiceFormPart>
            name={'receptionService.value'}
            testId={'receptionService'}
            register={props.register}
            columns={columns}
            header={
               <ReceptionServiceInteractiveTableSelector
                  register={props.register}
                  control={props.control}
                  receptionsServices={props.receptionServices}
                  setValue={props.setValue}
               />
            }
            summaryElement={
               <ReceptionServiceInteractiveTableSummary
                  onlinePaymentsIntegrationExists={props.onlinePaymentsIntegrationExists}
               />
            }
            autoScroll={'start'}
         />
      </>
   );
};

type ReceptionServiceInteractiveTableProps = Pick<
   ReceptionServiceFormController,
   'register' | 'control' | 'sync' | 'setValue'
> & {
   readonly practitionerId: PractitionerId;
};

export const ReceptionServiceInteractiveTable = (props: ReceptionServiceInteractiveTableProps): JSX.Element => {
   useUpdateEffect(() => {
      props.sync({ receptionService: { value: [], selector: [] } });
   }, [props.practitionerId.asNumber()]);

   return (
      <ReceptionServiceInteractiveTableLoader practitionerId={props.practitionerId}>
         {({ receptionServices, onlinePaymentsIntegrationExists }) => (
            <BaseReceptionServiceInteractiveTable
               {...props}
               onlinePaymentsIntegrationExists={onlinePaymentsIntegrationExists}
               receptionServices={receptionServices}
            />
         )}
      </ReceptionServiceInteractiveTableLoader>
   );
};
